import { Box, CssBaseline } from '@ds/coolshop';
import { Outlet, useLocation } from 'react-router-dom';

import { CartProvider } from './_new/modules/cpq/components/Cart/CartContext';
import { CartDrawer } from './_new/modules/cpq/components/Cart/CartDrawer';
import DirtyNavigationBlocker from './components/hierarchies/shared/DirtyNavigationBlocker';
import { PimAppBar } from './components/layout/PimAppBar';

const Layout = () => {
    const { pathname } = useLocation();
    const isCGTPrototypesPage = pathname.split('/')[1] === 'prototypes';

    return (
        <CartProvider>
            <Box>
                <CssBaseline />
                <DirtyNavigationBlocker />
                {!isCGTPrototypesPage && <PimAppBar />}
                <Box
                    flexGrow={!isCGTPrototypesPage ? 1 : undefined}
                    height={!isCGTPrototypesPage ? 'calc(100vh - 64px)' : undefined}
                    overflow={!isCGTPrototypesPage ? 'auto' : undefined}
                    marginTop={!isCGTPrototypesPage ? '64px' : undefined} // TODO this is the height of the appBar
                >
                    <Outlet />
                </Box>
                <CartDrawer />
            </Box>
        </CartProvider>
    );
};

export default Layout;
